import { FC } from 'react';
import Link from 'next/link';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { IBookDetailGenre } from '@/interfaces/bookDetail.interface';

interface IBookBreadcrumbs {
  bookTitle: string;
  bookAlias: string;
  genres: IBookDetailGenre[];
  authorFullName: string;
  authorAlias: string;
  isExtraPage?: boolean;
  extraPageName?: string;
}

const BookBreadcrumbs: FC<IBookBreadcrumbs> = ({ bookTitle, bookAlias, authorFullName, authorAlias, genres, isExtraPage, extraPageName }) => {
  const currentPath = String(useGetUrlPath());

  const bookFullAlias = `/authors/${authorAlias}/${bookAlias}`;
  const authorFullAlias = `/authors/${authorAlias}`;

  const getReadBookPageUrl = () => {
    if (currentPath.includes('read')) {
      return true;
    }
  };

  return (
    <ul className="breadcrumbsList">
      <li className="breadcrumbsList__item">
        <Link prefetch={false} className="breadcrumbsList__itemLink" href="/">
          Главная
        </Link>
      </li>
      {genres && genres.length > 0 && (
        <li className="breadcrumbsList__item">
          {'📚'}
          <Link prefetch={false} className="breadcrumbsList__itemLink breadcrumbsList__itemLink_genre" href={`/genres/${genres[0].alias}`}>
            {genres[0].title}
          </Link>
        </li>
      )}
      <li className="breadcrumbsList__item">
        {'▶ '}
        <Link prefetch={false} className="breadcrumbsList__itemLink" href={authorFullAlias}>
          {authorFullName}
        </Link>
      </li>
      <li className="breadcrumbsList__item">
        {'✔️ '}
        {!!isExtraPage ? (
          <Link prefetch={false} className="breadcrumbsList__itemLink" href={bookFullAlias}>
            {bookTitle}
          </Link>
        ) : (
          <>{bookTitle}</>
        )}
      </li>
      {!!isExtraPage && <li className="breadcrumbsList__item">{extraPageName}</li>}
    </ul>
  );
};

export default BookBreadcrumbs;
